import React from 'react';
import { FaMap, FaDownload } from 'react-icons/fa';
import { BiHealth } from 'react-icons/bi';
import { GiRiver } from 'react-icons/gi';
import { MdSchool } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import Card from '~/Components/Card';
import { Content, Header, CardsContainer } from './styles';
import { COLORS } from '~/styles/colors';
import Footer from '~/Components/Footer';

function MapotecaDigital() {
	const history = useHistory();
	return (
		<>
			<Content>
				<Header>MAPOTECA DIGITAL</Header>
				<p>Links úteis</p>
				<CardsContainer>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						onClick={() =>
							history.push('/media/mapoteca-digital/ambiental')
						}
						target="_blank"
						icon={<GiRiver size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Ambiental</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						onClick={() =>
							history.push(
								history.push(
									'/media/mapoteca-digital/politico-administrativo'
								)
							)
						}
						target="_blank"
						icon={<FaMap size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Político-Administrativo</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						onClick={() =>
							history.push('/media/mapoteca-digital/saude')
						}
						target="_blank"
						icon={<BiHealth size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Saúde</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						onClick={() =>
							history.push('/media/mapoteca-digital/educacao')
						}
						target="_blank"
						icon={<MdSchool size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Educação</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						onClick={() =>
							history.push('/media/mapoteca-digital/diversos')
						}
						target="_blank"
						icon={<FaDownload size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Diversos</span>
							</span>
						}
					/>
				</CardsContainer>
			</Content>
			<Footer />
		</>
	);
}

export default MapotecaDigital;
